import { Alert, AlertIcon, Text } from '@chakra-ui/react';
import React, { useState } from 'react';

const getElapsedTimeInSeconds = (startTime: number) =>
  Math.floor((Date.now() - startTime) / 1000);

// this component is used to display the time elapsed since the tape was generated
export const TimeCounterAlert = ({
  startTime,
  status,
}: {
  startTime: number;
  status: 'success' | 'info' | 'warning' | 'error';
}) => {
  const [time, _setTime] = useState(getElapsedTimeInSeconds(startTime));

  // TODO: need to debug why this time change is causing
  // other components to re-render
  // disabing the update for now and will debug
  // useEffect(() => {
  //   const UPDATE_INTERVAL = 1000 * 1; // 1 seconds
  //   const timer = setInterval(() => {
  //     // update elapsed time.
  //     setTime(getElapsedTimeInSeconds(startTime));
  //   }, UPDATE_INTERVAL);

  //   return () => clearInterval(timer);
  // }, [startTime]);

  const totalMinutes = Math.floor(time / 60);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const seconds = time % 60;

  const timeText = `+${hours}h:${minutes}m:${seconds}s`;

  return (
    <Alert status={status} variant="subtle" fontFamily="monospace">
      <AlertIcon />
      <Text fontFamily="monospace">{timeText}</Text>
    </Alert>
  );
};
